module.exports = __webpack_public_path__ + "components/rewards/armadillo/static/icon-9e02098239525253f02526b86c7f6a13.svg";